export const WOODEN = 'WOODEN'
export const IRON_RANGE_WOODEN = 'IRON_RANGE_WOODEN'
export const PLASTIC = 'PLASTIC'
